export type OrderChargeRowSource = {
  order_charges?: unknown;
} | null | undefined;

export type OrderChargesBlock = {
  shipping_option?: unknown[];
  specialfee?: unknown[];
};

export type CheckoutOrderChargeFallbacks = {
  shippingRows: unknown[];
  feeRows: unknown[];
};

function asRowArray(val: unknown): unknown[] {
  return Array.isArray(val) ? val : [];
}

/** Read `order_charges[0]` from a saved order or resolve response. */
export function readOrderChargesBlock(
  source: OrderChargeRowSource
): OrderChargesBlock {
  const charges = source?.order_charges;
  if (!charges) {
    return { shipping_option: [], specialfee: [] };
  }

  if (Array.isArray(charges)) {
    const block = (charges[0] ?? {}) as OrderChargesBlock;
    return {
      shipping_option: asRowArray(block.shipping_option),
      specialfee: asRowArray(block.specialfee),
    };
  }

  const flat = charges as OrderChargesBlock;
  return {
    shipping_option: asRowArray(flat.shipping_option),
    specialfee: asRowArray(flat.specialfee),
  };
}

/** Prefer live checkout ship/fee payloads; fall back to rows already on the order. */
export function getCheckoutOrderChargeFallbacks(input: {
  shipPayload?: { shipping_option?: unknown[] } | null;
  feePayload?: { specialfee?: unknown[] } | null;
  savedOrder?: OrderChargeRowSource;
}): CheckoutOrderChargeFallbacks {
  const saved = readOrderChargesBlock(input.savedOrder);
  const shippingFromPayload = asRowArray(input.shipPayload?.shipping_option);
  const feeFromPayload = asRowArray(input.feePayload?.specialfee);

  return {
    shippingRows:
      shippingFromPayload.length > 0
        ? shippingFromPayload
        : saved.shipping_option ?? [],
    feeRows:
      feeFromPayload.length > 0 ? feeFromPayload : saved.specialfee ?? [],
  };
}

/** Build the API `order_charges` wrapper from resolved shipping/fee rows. */
export function coalesceOrderChargeRows(input: {
  shippingRows?: unknown[];
  feeRows?: unknown[];
}): Array<{ shipping_option: unknown[]; specialfee: unknown[] }> {
  return [
    {
      shipping_option: asRowArray(input.shippingRows),
      specialfee: asRowArray(input.feeRows),
    },
  ];
}
